import { errors } from './toastCaller'

export const translateError = (
	errorCode?: string | null,
	objectName?: string
): string | null => {
	if (!errorCode) return null

	if (errors[errorCode]) {
		return errors[errorCode](objectName)
	}

	const match = errorCode.match(/^(\w+)_SAME_NAME_EXISTS$/)
	if (match) {
		const [, name] = match
		return errors.SAME_NAME_EXISTS(objectName, name)
	}

	return null
}
